import { styled, css } from 'styled-components';

export const TabSectionContainer = styled.div`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
`;

export const TabSectionWrapper = styled.div<{ $alternativeStyling?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 96px 24px;

  ${({ theme, $alternativeStyling }) =>
    $alternativeStyling &&
    css`
      background: ${theme.colors.default[0]};

      > div {
        > div {
          > div {
            &:first-of-type {
              background: ${theme.colors.default[100]};
              > div {
                background: ${theme.colors.default[100]};
                color: ${theme.colors.default[700]};
                &[data-is-active='true'] {
                  background: ${theme.colors.default[50]};
                  color: ${theme.colors.primary.default};
                }
              }
            }
            &:last-of-type {
              background: ${theme.colors.default[50]};
            }
          }
        }
      }
    `}
`;
